import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { rem } from '@bonusly/design-system';

import { Panel } from '../../../components/panel';
import { RewardsHighlightsContent } from '../../../components/rewards/highlights/rewards-highlights-content';
import { useLinkNavigation } from '../hooks/use-link-navigation';

interface RewardsHighlightsPanelProps {
	isOpen: boolean;
	isSidebarExpanded: boolean;
	onClose: () => void;
}

export const RewardsHighlightsPanel: FC<RewardsHighlightsPanelProps> = ({ isOpen, isSidebarExpanded, onClose }) => {
	const { t } = useTranslation('navigation');
	const navigate = useNavigate();
	const { isCrossDomain, url } = useLinkNavigation({ path: '/rewards', isRecognizeRoute: false });

	const handleShopAllClick = () => {
		onClose();
		if (isCrossDomain) {
			// In MFE context: full page reload to Rails app
			window.location.href = url;
		} else {
			// In SPA context: React Router navigation
			navigate('/rewards');
		}
	};

	return (
		<Panel
			isOpen={isOpen}
			onClose={onClose}
			isSidebarExpanded={isSidebarExpanded}
			title={t('rewardsPanel.title')}
			closeButtonLabel={t('rewardsPanel.close')}
			width={rem(400)}
			data-testid="rewards-highlights-panel"
		>
			<RewardsHighlightsContent onShopAllClick={handleShopAllClick} />
		</Panel>
	);
};
